import { render, staticRenderFns } from "./DetailAppr.vue?vue&type=template&id=31ac9e0b&scoped=true&"
import script from "./DetailAppr.vue?vue&type=script&lang=js&"
export * from "./DetailAppr.vue?vue&type=script&lang=js&"
import style0 from "./DetailAppr.vue?vue&type=style&index=0&id=31ac9e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac9e0b",
  null
  
)

export default component.exports